export const dateInputValue = (value = new Date()) => `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`

// 快捷范围以本地日界线生成，避免UTC日期导致北京时间凌晨跨日。
export function recordDateRange(days = 7, now = new Date()) {
  const end = new Date(now)
  const start = new Date(now)
  if (days === -1) {
    end.setDate(end.getDate() - 1)
    start.setDate(start.getDate() - 1)
  } else start.setDate(start.getDate() - Math.max(0, days - 1))
  return { start: dateInputValue(start), end: dateInputValue(end) }
}

export function buildRecordQuery(filters, pageNumber = 1, pageSize = 10) {
  if (filters.start && filters.end && filters.start > filters.end) throw new Error('开始日期不能晚于结束日期')
  return {
    pageNumber,
    pageSize,
    ...(filters.start ? { startTime: `${filters.start} 00:00:00` } : {}),
    ...(filters.end ? { endTime: `${filters.end} 23:59:59` } : {}),
  }
}

export function displayRecordTime(value) {
  if (!value) return '--'
  const date = new Date(typeof value === 'number' || /^\d+$/.test(String(value)) ? Number(value) * 1000 : value)
  if (Number.isNaN(date.getTime())) return String(value)
  return `${dateInputValue(date)} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`
}

// 资金页入口只接受既有记录类型，刷新或同路由查询切换时继续查询原分类。
export function recordTypeFromSearch(search = '') {
  const type = new URLSearchParams(search).get('type')
  return ['deposit', 'transfer', 'withdrawal', 'wallet'].includes(type) ? type : 'deposit'
}
